(function () {
  'use strict';

  /* @ngdoc object
   * @name dailyOpsReport
   * @description
   *
   */
  angular
    .module('dailyOpsReport', [
      'ui.router'
    ]);
}());
